/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section6_TitleInputs */

const en_terms_section6_title = /** @type {(inputs: Terms_Section6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changes to Terms`)
};

const ko_terms_section6_title = /** @type {(inputs: Terms_Section6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`약관 변경`)
};

const ja_terms_section6_title = /** @type {(inputs: Terms_Section6_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`規約の変更`)
};

/**
* | output |
* | --- |
* | "Changes to Terms" |
*
* @param {Terms_Section6_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const terms_section6_title = /** @type {((inputs?: Terms_Section6_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section6_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_terms_section6_title(inputs)
	if (locale === "ko") return ko_terms_section6_title(inputs)
	return ja_terms_section6_title(inputs)
});